import { useUserStore } from "../user/user.store";
import { useAuthStore } from "./auth.store";
import type { AuthUser } from "./auth.types";

const MOCK_ACCESS_TOKEN = "mock-access-token";
const MOCK_REFRESH_TOKEN = "mock-refresh-token";

const MOCK_USER: AuthUser = {
	id: "cmc0000000000000000000000",
	email: "mock.user@inflect.dev",
	name: "Mock User",
	plan: "PRO",
	gyulBalance: 9999,
};

export const isMockAuthEnabled = () => import.meta.env.VITE_MOCK_AUTH === "enabled";

export const ensureMockAuthSession = () => {
	if (!isMockAuthEnabled()) {
		return false;
	}

	const auth = useAuthStore.getState();
	if (auth.accessToken && auth.user) {
		return true;
	}

	useAuthStore.getState().setAuth({
		accessToken: MOCK_ACCESS_TOKEN,
		refreshToken: MOCK_REFRESH_TOKEN,
		user: MOCK_USER,
	});
	useUserStore.getState().setMe(MOCK_USER);

	return true;
};
